import { Component } from '@angular/core';
import { PhcUrl } from '../../../../models/interfaces/portfolio-health-check-data';
import { getPHCUrls } from '../../../../utils/functions.utils';
import { AdobeAnalyticsService, CallToActionType } from 'src/app/services/adobe-analytics/adobe-analytics.service';

@Component({
  selector: 'phc-use-available-cash-accordion',
  templateUrl: './use-available-cash-accordion.component.html',
  styleUrls: ['./use-available-cash-accordion.component.scss']
})
export class UseAvailableCashAccordionComponent {

  urls: PhcUrl = {}

  constructor(
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.urls = getPHCUrls()
  }

  callToAction(name: string, type: CallToActionType) {
    this.adobeAnalyticsService.CreateCTATrigger('rebalancing-your-portfolio-use-available-cash-accordion', name, type);
  }
}
